import { signupGateway } from "@/gateways/signupGateway";
import type { Redirect } from "@/login/types";
import { useMutation } from "@tanstack/vue-query";

export function useCreateSignup(redirect: Redirect) {
  const mutation = useMutation({
    mutationFn: (email: string) =>
      signupGateway.createSignup({
        email: email.trim().toLowerCase(),
        params: redirect,
      }),
  });

  return { ...mutation, signup: mutation.mutate };
}
